'use strict';

$(document).on('change', '#orderform-catalog_shipment_id', function (e) {
    var el = $(e.target);

    var id = el.val();
    var url = el.attr('data-url');
    $.ajax({
        url: url,
        type: "post",
        data: { id: id },
        dataType: 'json',
        success: function success(data) {
            $('#order-form-delivery').html(data.shipment);
            $('#order-form-payment').html(data.payments);
            // console.log(data);
        }
    });
});
$(document).on('change', '#order-form-payment', function (e) {
    var el = $(e.target);

    var id = el.val();
    var url = $('#order-form-payment').attr('data-url');
    $.ajax({
        url: url,
        type: "post",
        data: { id: id },
        dataType: 'json',
        success: function success(data) {}
    });
});

$(document).ajaxComplete(function (event, xhr, settings) {

    if (settings.type !== 'GET') {
        $.Cart.get();
    }
});